import React, { Component } from 'react'
import { Alert } from 'loyal-react'

import ProductOrderItem from './ProductOrderItem'
import PropTypes from 'prop-types'
import '@loyal_template/cart.css'
import '@loyal_template/confirmation.css'
import { AboutOrder } from '../AboutOrder'
import { ModalEvaluationDonation } from './ModalEvaluationDonation'
import clients from 'redux/clients'
import slugify from 'react-slugify'
import { ToggleFeature, features } from 'features/ToggleFeature'

import yn from 'yn'

import { withLastLocation } from 'react-router-last-location'

const VENDORTYPEDONATION = 'Doação'
class Confirmation extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showModal: false,
      hideModal: true,
      showAlert: true
    }

    if (this.props.lastLocation.pathname === '/checkout') {
      this.state = {
        sendGTM: false
      }
    }

    const {
      cloudloyalty: { client }
    } = clients
    this.client = client
  }

  componentDidMount () {
    if (this.props.orderId) {
      this.props.getOrder(this.props.orderId)

      const utmURL = window.sessionStorage.getItem('utm-url')
      if (utmURL) {
        this.client
          .post(`v1/purchases/utm`, {
            ParentOrderId: this.props.orderId,
            Url: utmURL
          })
      }
    }

    !yn(process.env.REACT_APP_DISABLE_DONATION_MODAL) && this.toogleModal()

    if (!yn(process.env.REACT_APP_DISABLE_DONATION_MODAL)) { this.getDonationStatus() }
    this.props.loadBalance()
  }
  state = {
    showModal: false,
    hideModal: true,
    showAlert: true,
    vendorType: '',
    isDonationCampaign: false
  }

  getDonationStatus () {
    this.client
      .get(`/v1/donation/status`)
      .then(result => {
        this.setState({ isDonationCampaign: result.data })
        if (!result.data) {
          this.toogleModal()
        }
      })
      .catch(_ => {
        yn(process.env.REACT_APP_NPS_GFORMS) && this.toogleModal()
      })
  }

  toogleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }
  onCloseAlert = () => {
    this.setState({ showAlert: !this.state.showAlert })
  }
  sendGTM () {
    const props = this.props

    if (Object.entries(props.order).length > 0) {
      this.setState({ sendGTM: true })

      const order = props.order
      const purchaseType = (order && order.vendorOrderModel && order.vendorOrderModel[0].vendorType === 'Compra de Pontos') || order.paymentType === 5 ? 'resgate:points+cash' : 'resgate:points'
      const moneyValue = (order && order.vendorOrderModel && order.vendorOrderModel[0].vendorType === 'Compra de Pontos') || order.paymentType === 5 ? parseFloat(order.orderPaymentDetailMoneyAndPoints.valuePurchase.replace('.', '').replace(',', '.')) : undefined
      const orderTotalValue = (order && order.vendorOrderModel && order.vendorOrderModel[0].vendorType === 'Compra de Pontos') || order.paymentType === 5 ? undefined : order.orderTotalValue.toFixed(2)

      const productsList = []

      order.vendorOrderModel.map(vendorItem => {
        vendorItem.items.map((item, index) => {
          return (
            productsList.push({
              'name': slugify(item.name, { delimiter: ' ' }),
              'id': item.productSkuId,
              'price': this.props.order.paymentType === 5
                ? undefined
                : item.sellingPrice.toFixed(2),
              'brand': undefined,
              'category': item.categoryName ? slugify(item.categoryName, { delimiter: ' ' }) : undefined,
              'variant': undefined,
              'quantity': item.quantity,
              'coupon': undefined,
              'dimension5': vendorItem.vendorId ? 'vendor-' + vendorItem.vendorId : undefined,
              'metric2': item.currencySellingPrice ? item.currencySellingPrice.toFixed(2) : undefined
            })
          )
        })
      })

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'purchase',
        'eventCategory': 'enhanced-ecommerce',
        'eventAction': 'purchase',
        'dimension4': purchaseType,
        'metric1': moneyValue,
        'ecommerce': {
          'purchase': {
            'actionField': {
              'id': order.parentOrderId,
              'revenue': orderTotalValue,
              'shipping': order && order.orderTotalShippingValue ? order.orderTotalShippingValue.toFixed(2) : undefined,
              'tax': '0.00',
              'coupon': undefined
            },
            'products': productsList
          }
        }
      })
    }
  }

  render () {
    if (this.state.sendGTM === false) {
      this.sendGTM()
    }
    let donationOrder = false
    if (this.props.order.notFound) {
      this.props.history.push('/auth/logout')
    } else if (this.props.order.vendorOrderModel) {
      donationOrder =
        this.props.order.vendorOrderModel.findIndex(
          item => item.vendorType === VENDORTYPEDONATION
        ) !== -1
    }

    let successMsg =
      this.props.lastLocation &&
        this.props.lastLocation.pathname.toString().indexOf('points-purchase') > -1
        ? 'Parabéns! Sua compra foi concluída com sucesso'
        : 'Parabéns! Seu resgate foi concluído com sucesso.'
    let cash =
      this.props.order.orderPaymentDetailMoneyAndPoints &&
      this.props.order.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal
    let pointsUsedDecimal =
      this.props.order.orderPaymentDetailMoneyAndPoints &&
      this.props.order.orderPaymentDetailMoneyAndPoints.pointsUsedDecimal
    let msgCash =
      cash > 0
        ? ', e lembre-se que seus pontos de cashback serão creditados em até 30 dias.'
        : '.'

    msgCash = this.props.lastLocation &&
      this.props.lastLocation.pathname.toString().indexOf('points-purchase') > -1
      ? ', seus pontos serão creditados em instantes.' : msgCash

    const barCode =
          this.props.order.vendorOrderModel &&
          this.props.order.vendorOrderModel[0].items[0] &&
          this.props.order.vendorOrderModel[0].items[0].itemConfiguration &&
      this.props.order.vendorOrderModel[0].items[0].itemConfiguration.filter(config => config.key === 'BarCode')[0]

    const dueDate =
          this.props.order.vendorOrderModel &&
          this.props.order.vendorOrderModel[0].items[0] &&
          this.props.order.vendorOrderModel[0].items[0].itemConfiguration &&
      this.props.order.vendorOrderModel[0].items[0].itemConfiguration.filter(config => config.key === 'DueDate')[0]

    const productName =
          this.props.order.vendorOrderModel &&
          this.props.order.vendorOrderModel.map((vendorItem) =>
            vendorItem.items.map((item) => item.name)[0]
          )[0]

    return (
      <div
        className='container-cart container px-0 pt-0 pt-sm-2 pb-5'
      >
        { !this.state.showModal && process.env.REACT_APP_NPS_GFORMS &&
        <ToggleFeature
          feature={features.NpsGoogleForms}
          closeDonation={!this.state.showModal}
        />}

        {this.props.isDonationCampaign && donationOrder ? (
          <Alert
            isError={false}
            title='Obrigado! Sua doação foi concluída com sucesso.'
            description='Veja abaixo o resumo do seu pedido.'
            className={`mt-0 mt-sm-0 mb-2 ${!this.state.showAlert && 'd-none'}`}
            onClose={e => this.onCloseAlert()}
          />
        ) : (
          <Alert
            isError={false}
            title={successMsg}
            className={`mt-0 mt-sm-0 mb-2 ${!this.state.showAlert && 'd-none'}`}
            description={'Veja abaixo o resumo do seu pedido' + msgCash}
            onClose={e => this.onCloseAlert()}
          />
        )}
        <div id='confirmation-content' className='row mx-0'>
          <div className='cart-side col-12 col-md-8 pl-0 pr-0 pr-md-2'>
            <div className='border-ui-3 radius bg-white'>
              <div className='col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'>
                {this.props.isDonationCampaign && donationOrder ? (
                  <h1 className='color-title txt-font-body h3'>
                    Resumo da doação
                  </h1>
                ) : (
                  <h1 className='color-title txt-font-body h3'>
                    Resumo do pedido
                  </h1>
                )}
              </div>
              <div className='cart-products col-12 mx-0'>
                {this.props.order.vendorOrderModel
                  ? this.props.order.vendorOrderModel.map(vendorItem =>
                    vendorItem.items.map((item, index) => (
                      <ProductOrderItem
                        key={index}
                        orderParentId={this.props.order.parentOrderId}
                        sellingPrice={
                          this.props.order.paymentType === 5
                            ? cash
                            : pointsUsedDecimal !== item.sellingPrice &&
                              pointsUsedDecimal !== 0
                              ? pointsUsedDecimal
                              : item.sellingPrice
                        }
                        quanttity={item.quantity}
                        vendorName={vendorItem.vendorName}
                        deliveryDate={item.deliveryForecastParticipant}
                        orderId={vendorItem.orderId}
                        parentOrderId={this.props.order.parentOrderId}
                        productId={item.id}
                        imageUrl={item.imageUrl}
                        vendorId={vendorItem.vendorId}
                        vendorType={vendorItem.vendorType}
                        redirect={this.props.redirect}
                        paymentType={this.props.order.paymentType}
                        cash={cash}
                        packageSize={this.props.packageSize}
                        dueDate={dueDate}
                        barCode={barCode}
                      />
                    ))
                  )
                  : ''}
              </div>
            </div>
          </div>
          <AboutOrder
            campaignHasDonation={
              this.state.isDonationCampaign && !donationOrder
            }
            parentOrder={this.props.order}
            productName={productName}
          />
          {this.state.isDonationCampaign && !donationOrder ? (
            <ModalEvaluationDonation
              show={this.state.showModal}
              onClose={e => this.toogleModal()}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    )
  }
}

Confirmation.propTypes = {
  order: PropTypes.object,
  orderId: PropTypes.number,
  getOrder: PropTypes.func,
  history: PropTypes.object,
  isDonationCampaign: PropTypes.bool,
  lastLocation: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string
  }),
  redirect: PropTypes.func,
  loadBalance: PropTypes.func,
  packageSize: PropTypes.number
}

Confirmation.defaultProps = {
  lastLocation: null
}

export default withLastLocation(Confirmation)



// WEBPACK FOOTER //
// ./src/features/Confirmation/Confirmation.js